import { render, staticRenderFns } from "./CheckupNotifications.vue?vue&type=template&id=6ab1bcae"
import script from "./CheckupNotifications.vue?vue&type=script&lang=js"
export * from "./CheckupNotifications.vue?vue&type=script&lang=js"
import style0 from "./CheckupNotifications.vue?vue&type=style&index=0&id=6ab1bcae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports